import React from "react";

// Cute chat-bubble mascot (à la the reference logo): a rounded speech-bubble
// outline with a white face, two shiny eyes, a solid smile, and a detached dot.
// Colours are props so it works on the launcher (green ring / white face) and
// on the header (white ring / see-through face).
const FushiMascot = ({
  size = 54,
  outlineColor = "#17bd3b",
  faceColor = "#ffffff",
  featureColor = "#1c1c1c",
  shineColor = "#ffffff",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 44 44"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    {/* bubble body — fill is the face, stroke is the ring */}
    <rect
      x="6"
      y="5"
      width="30"
      height="27"
      rx="11"
      fill={faceColor}
      stroke={outlineColor}
      strokeWidth="4"
    />
    {/* detached dot (speech-bubble tail) */}
    <circle cx="9" cy="37.5" r="3" fill={outlineColor} />

    {/* eyes */}
    <ellipse cx="17" cy="16" rx="2.7" ry="3.4" fill={featureColor} />
    <ellipse cx="25" cy="16" rx="2.7" ry="3.4" fill={featureColor} />
    {/* sparkle highlights */}
    <circle cx="18.1" cy="14.4" r="0.95" fill={shineColor} />
    <circle cx="26.1" cy="14.4" r="0.95" fill={shineColor} />

    {/* smile */}
    <path d="M16.2 21.6 A5 4.5 0 0 0 25.8 21.6 Z" fill={featureColor} />
  </svg>
);

export default FushiMascot;
